import PropTypes from 'prop-types';
import React from 'react';

const ReviewLabelText: React.FC = (props) => (
  <h6 className="all-caps faded u-display-inline-block">{props.children}</h6>
);

ReviewLabelText.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ReviewLabelText;
